import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Footer } from './Footer';
import '../style.css';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <div>
        <NavMenu />

        <Container>
          <main>
          {this.props.children}
          </main>
        </Container>

        <Footer />
      </div>
    );
  }
}
